// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Base, Hide } from '@gandi/ui';

import ErrorIcon from './Svg/error';
import FailIcon from './Svg/fail';
import OkIcon from './Svg/ok';
import WarningIcon from './Svg/warning';

import styles from './AvailabilityIcon.scss';

const svgComponent = {
  ok: OkIcon,
  warning: WarningIcon,
  fail: FailIcon,
  error: ErrorIcon,
} as const;

export type AvailabilityIconName = 'fail' | 'ok' | 'warning'; // | 'error' | 'loading',

type Props = {
  iconName: AvailabilityIconName,
  className?: string,
};

export function AvailabilityIcon({
  iconName,
  className,
}: Props): React.MixedElement {
  const Svg = svgComponent[iconName];

  return (
    <Base
      flex
      flexShrink0
      flexAlignItemsCenter
      flexJustifyCenter
      className={clsx(className, styles[iconName], styles.round)}
    >
      <Svg aria-hidden="true" className={styles.svg} />
    </Base>
  );
}

type LayoutProps = {
  ...Props,
  layout: 'mobile' | 'desktop',
};
/** @deprecated Component to remove when DomainRowContainer uses grid layout like Unavailable */
export function AvailabilityIconLayout({
  iconName,
  className,
  layout,
}: LayoutProps): React.MixedElement {
  return (
    <Hide
      until={layout === 'desktop' ? 'sm' : undefined}
      from={layout === 'mobile' ? 'sm' : undefined}
    >
      <AvailabilityIcon
        iconName={iconName}
        className={clsx(className, styles[layout])}
      />
    </Hide>
  );
}
